import { InjectionToken } from '@angular/core';
import * as Auth from 'aws-amplify/auth';

export const AMPLIFY_AUTH = new InjectionToken('AMPLIFY_AUTH', {
  factory: () => Auth,
});
